import * as React from "react";
import "flag-icons/css/flag-icons.min.css";
import { SearchableSelect } from "./SearchableSelect";
import { NATIONALITIES, DEFAULT_COUNTRY, filterCountries } from "../../../data/nationalities";

/**
 * Land einer Anschrift: suchbares Dropdown aller Länder (mit Flagge), Default
 * „Deutschland". Gespeichert wird der deutsche Ländername (`ContactAddress.country`).
 *
 * Zwillingswidget zu {@link NationalitySelect}: dort das Adjektiv („Deutsch"),
 * hier der Ländername („Deutschland") — dieselbe Datenquelle, damit Land und
 * Staatsangehörigkeit nicht auseinanderlaufen.
 *
 * `autoDefault` (Default true): setzt bei leerem Wert automatisch „Deutschland" —
 * gewünscht in der Anlage. In der Detailansicht MUSS es abgeschaltet werden
 * (`autoDefault={false}`), sonst würde ein Kontakt ohne Landangabe beim bloßen
 * Öffnen „dirty".
 */

const Flag: React.FC<{ code: string }> = ({ code }) => (
  <span
    className={`fi fi-${code.toLowerCase()}`}
    style={{ width: 18, height: 13, borderRadius: 2, flexShrink: 0, backgroundSize: "cover" }}
  />
);

export function CountrySelect({
  label = "Land",
  name = "country",
  value,
  onChange,
  required,
  autoDefault = true,
}: {
  label?: string;
  name?: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  autoDefault?: boolean;
}) {
  // Default „Deutschland" persistieren, falls leer — nur wenn autoDefault aktiv.
  React.useEffect(() => {
    if (autoDefault && !value) onChange(DEFAULT_COUNTRY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const effective = value || (autoDefault ? DEFAULT_COUNTRY : "");
  const current = NATIONALITIES.find((n) => n.country === effective);

  return (
    <SearchableSelect
      label={label}
      name={name}
      value={effective}
      required={required}
      placeholder="Land suchen …"
      leftIcon={current ? <Flag code={current.code} /> : undefined}
      allowFreeText
      emptyText="Kein Land gefunden"
      // Vollständige Liste zulassen — sonst kappt SearchableSelects Default (50)
      // die alphabetische Liste mitten im „G".
      maxResults={NATIONALITIES.length}
      onChange={onChange}
      filter={(q) =>
        filterCountries(q).map((n) => ({
          value: n.country,
          label: n.country,
          icon: <Flag code={n.code} />,
        }))
      }
    />
  );
}

export default CountrySelect;
